import globalMixin from '../globalMixin'
import mixins from 'vue-typed-mixins'
import { FormulaireInputOutput, FormulaireOutput } from './models/formulaire'
import { FormulaireRepondu, FormulaireRepondu_Reponse } from '@/domain/FormulaireRepondu'
import _ from 'lodash'

export default mixins(globalMixin).extend({
    data() {
        return {
            formulairesModeles: [] as FormulaireOutput[],
            formulaireModele: null as null | FormulaireOutput,
            formulaireRepondu: null as null | FormulaireRepondu,
            form: false,
            messageConfirmationEnvoi: null as string | null
        }
    },
    mounted() {
        this.loadModelesFormulaires()
    },
    computed: {
        dicQuestions(): { [id: number]: FormulaireInputOutput } {
            if (!this.formulaireModele) return {}

            return _.chain(this.formulaireModele.inputs)
                .keyBy('id')
                .mapValues()
                .value()
        }
    },
    methods: {
        loadModelesFormulaires() {
            this.$loader.go()
            this.$http
                .api(`formulaireReponse/all-modeles`)
                .get()
                .then(x => {
                    this.formulairesModeles = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        commencerReponseFormulaire(modele: FormulaireOutput) {
            this.formulaireModele = modele
            this.formulaireRepondu = new FormulaireRepondu()
            this.formulaireRepondu.idModeleFormulaire = modele.id
            this.formulaireRepondu.reponses = _.map(this.formulaireModele.inputs, input => {
                const question = new FormulaireRepondu_Reponse()
                question.idQuestion = input.id
                question.reponse = input.estNumerique && !input.facultatif ? '' : ''
                return question
            })
        },
        save() {
            if (!this.form) return this.$swal.toast.error('Vérifiez que tous les champs du formulaires sont remplis avant de valider')
            this.$loader.go()
            this.$http
                .api(`formulaireReponse`)
                .post(this.formulaireRepondu)
                .then(x => {
                    this.$swal.toast.success()
                    this.formulaireModele = null
                    this.formulaireRepondu = null
                    this.messageConfirmationEnvoi = 'Votre demande a bien été transmise et sera traitée dans les meilleurs délais.'
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        cancel() {
            this.formulaireModele = null
            this.formulaireRepondu = null
        },
        rulesQuestion(question: FormulaireInputOutput) {
            return question.facultatif ? [] : [this.isFilled]
        },
        labelQuestion(question: FormulaireInputOutput) {
            return `${question.titre}${question.facultatif ? '' : ' *'}`
        }
    }
})
